import { CardProps } from '@mui/material'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { useSiteDetails } from '../../hooks/useSiteDetails'
import { MoovyToast } from '../../utils/moovyToast'
import { appRoutes } from '../permissions'
import SystemStatus from './systemStatus'

const SystemStatusBanner = (props: CardProps) => {
  const siteDetailsQuery = useSiteDetails()
  const intl = useIntl()
  const location = useLocation()

  // Show a toast when there's an error loading the system status
  useEffect(() => {
    if (siteDetailsQuery?.isError && !siteDetailsQuery?.isFetching) {
      MoovyToast.showToast(
        intl.formatMessage({ id: 'common.system.statusCheckErrorToastText' }),
        'error',
      )
    }
  }, [siteDetailsQuery?.isError, siteDetailsQuery?.isFetching, intl])

  // Compare explicitly to `false` with strict equality instead of just general falsiness (!siteDetailsQuery.data...)
  // Also, do not render the banner if the user is already on the site page
  if (
    siteDetailsQuery?.data?.data.data?.systemStatus?.isEnabled === false &&
    location.pathname !== appRoutes.SITE
  ) {
    return <SystemStatus {...props} />
  }
  // Do not render by default
  return null
}

export default SystemStatusBanner
